<template>
  <v-form ref="formValid" v-model="valid">
    <v-dialog v-model="dialog" width="600" dark>
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          :id="`dat-version-${dat.uid}-edit`"
          :title="$t('common.edit')"
          class="mx-2"
          dark
          v-bind="attrs"
          v-on="on"
        >
          mdi-pencil-outline
        </v-icon>
      </template>
      <v-card class="dat-container">
        <v-card-title class="title pa-4 pl-11">{{ $t('map.tolldomains.dats.edit_dat_modal_title', { type: dat.type.toUpperCase() }) }}</v-card-title>
        <v-divider />
        <v-card-text class="content py-7 px-12">
          <v-row class="d-flex flex-column" dense justify="center">
            <div class="mb-1 mt-4 file-name required">{{ $t('map.tolldomains.dats.list.header_dat_name') }}</div>
            <v-text-field
              v-model="datname"
              class="file-name-input"
              outlined
              dark
              dense
              hide-details="auto"
              :rules="[...datnameRules, isUniqueString(datnames, 'common.error.forms.inputs.validator.datname_unicity')]"
            />
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-text class="pa-4 pl-11 add-file-actions">
          <v-btn
            class="ctp-btn my-0"
            dark
            :disabled="!valid"
            :color="colors.secondary"
            @click="saveDat"
          >
            {{ $t('common.confirm') }}
          </v-btn>
          <v-btn
            class="cancel"
            dark
            rounded
            @click="close"
          >
            {{ $t('common.cancel') }}
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-form>
</template>

<script lang="ts">
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { colors } from '@/constants/theme/colors';
import Validation from '@/mixins/Validation';
import { DatRelatedV3 } from 'ctp-toll-domain';

@Component
export default class EditDatDialog extends Mixins(Validation) {
    @Prop()
    private dat!: DatRelatedV3;

    @Prop()
    private datnames!: string[];

    @Prop()
    private masterAccount!: string;

    private datnameRules = [
      this.requiredRule('common.error.forms.inputs.validator.mandatory')
    ];

    private colors = colors;

    private datname = null;

    private dialog = false;

    private valid = false;

    private saveDat() {
      this.$emit('editDat', { id: this.dat.id, name: this.datname });
      this.close();
    }

    private close() {
      (this.$refs.formValid as HTMLFormElement).reset();
      this.dialog = false;
    }
}
</script>

<style lang="scss" scoped>
@import './styles/edit-dat.scss';
</style>
